import { Region } from '@getpopsure/public-models';
import { BLOG_PATHNAME } from 'constants/blog';
import { getQuerySegmentFromPath } from 'util/pathSegmentUtil';

export const getRegionLandingPageUrl = (
  newCountry: { languages: { id: string; label: string }[]; id: Region },
  asPath: string,
  isBlog?: boolean
): string => {
  const newCountryLanguageId = newCountry.languages?.[0]?.id;
  const isEnDe = newCountryLanguageId === 'en' && newCountry.id === 'de';

  if (isBlog && !isEnDe) {
    return `/${newCountryLanguageId}-${newCountry.id}${getQuerySegmentFromPath(
      asPath
    )}/${BLOG_PATHNAME}`;
  }

  if (isBlog && isEnDe) {
    return `/${BLOG_PATHNAME}`;
  }

  return `/${newCountryLanguageId}-${newCountry.id}${getQuerySegmentFromPath(
    asPath
  )}`;
};
